import * as THREE from "three"
import { TextGeometry } from "three/examples/jsm/Addons.js"
import Experience from "../../../Experience.js"
import Home from "./Home.js"
import Projects from "./Projects.js"
import Jobs from "./Jobs.js"
import Contact from "./Contact.js"
import { isTouchOnlyDevice } from "../../../Utils/InputDevice.js"
import Lab from "./Lab.js"

export default class Welcome {

    constructor() {

        this.home = new Home()
        this.experience = new Experience()
        this.resources = this.experience.resources
        this.interaction = this.home.interaction
        this.scene = this.home.scene
        this.name = null

        // Options
        this.titleFontSize = 2
        this.titleFontColor = "#9800D9"
        this.subtitleFontSize = 0.9
        this.subtitleFontColor = "#ffffff"
        this.selectionColor = "#fff319"
        this.gap = 1.7
        this.index = 0
        this.menuItems = []
        this.objects = []
        this.startingHeight = 0.0;

        // Check if resources are already ready
        if (this.resources.loaded === this.resources.toLoad) {
            this.setup()
        }
        else {
            this.resources.on("ready", () => {
                this.setup()
            })
        }


    }

    setup() {
        this.font = this.resources.items.font2
        this.image = this.resources.items.name

        const isTouchDevice = isTouchOnlyDevice()

        if (isTouchDevice) {
            this.moveImg = this.resources.items.dpad
            this.selectImg = this.resources.items.a
            this.backImg = this.resources.items.b
        } else {
            this.moveImg = this.resources.items.ws
            this.selectImg = this.resources.items.space
            this.backImg = this.resources.items.esc
        }

        this.isTouchDevice = isTouchDevice

        this.selector = this.resources.items.selector

        this.instructions()

        this.allTexts()
        this.interaction.setPrefs(
            this.menuItems,
            "#ffff00",
            "#acacac",
            true,
            1.2
        )
        // this.updateSelection()
        // this.setKeyboard()
    }

    instructions() {

        // Background

        this.planeSize = 5
        this.fontSize = 0.5

        // Move
        this.movePlane = new THREE.Mesh(
            new THREE.PlaneGeometry(this.planeSize, this.planeSize),
            new THREE.MeshBasicMaterial({
                map: this.moveImg,
                transparent: true
            })
        )
        this.movePlane.position.set(-8, -8.5, 0)
        this.scene.add(this.movePlane)
        this.setText("move", this.fontSize, this.subtitleFontColor, new THREE.Vector3(-7, -8.7, 0.3))

        // Select
        this.selectPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(this.planeSize, this.planeSize),
            new THREE.MeshBasicMaterial({
                map: this.selectImg,
                transparent: true
            })
        )
        this.selectPlane.position.set(-1, -8.5, 0)
        this.scene.add(this.selectPlane)
        this.setText("select", this.fontSize, this.subtitleFontColor, new THREE.Vector3(1, -8.7, 0.3))

        // Back
        this.backPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(this.planeSize, this.planeSize),
            new THREE.MeshBasicMaterial({
                map: this.backImg,
                transparent: true
            })
        )
        this.backPlane.position.set(6, -8.5, 0)
        this.scene.add(this.backPlane)
        this.setText("back", this.fontSize, this.subtitleFontColor, new THREE.Vector3(7.5, -8.7, 0.3))

        // Footer line
        this.footer = new THREE.Mesh(
            new THREE.PlaneGeometry(23, 0.1),
            new THREE.MeshBasicMaterial()
        )
        this.footer.position.y = -6.8
        this.scene.add(this.footer)
        this.objects.push(this.movePlane, this.selectPlane, this.backPlane, this.footer)



        // Selectors
        const selectorMaterial = new THREE.MeshBasicMaterial({
            map: this.selector,
            transparent: true
        })

        this.selectorLeft = new THREE.Mesh(
            new THREE.PlaneGeometry(0.8, 1.0),
            selectorMaterial
        )
        this.selectorLeft.scale.set(0.7, 0.7, 0.7)
        // this.scene.add(this.selectorLeft)

        this.selectorRight = new THREE.Mesh(
            new THREE.PlaneGeometry(0.8, 1.0),
            selectorMaterial.clone()
        )
        this.selectorRight.scale.set(-0.7, 0.7, 0.7)
        // this.scene.add(this.selectorRight)

        // this.objects.push(this.selectorLeft, this.selectorRight)

    }

    allTexts() {
        this.setText(
            "Hi, I'm",
            this.subtitleFontSize,
            this.subtitleFontColor,
            new THREE.Vector3(-5.8, 7, 0.3)
        )
        this.nameBackground = this.setText(
            "Abhishek",
            this.titleFontSize,
            "#3E0059",
            new THREE.Vector3(-5.6, 3.8, 0.3)
        )
        this.name = this.setText(
            "Abhishek",
            this.titleFontSize,
            this.titleFontColor,
            new THREE.Vector3(-5.8, 4, 0.3)
        )
        this.setText(
            ".. .. .. .. .. .. .. .. .. .. .. .. .. .. .. .. ..",
            // "Frontend Developer",
            0.6,
            this.subtitleFontColor,
            new THREE.Vector3(0, 3, 0.3),
            true
        )

        this.setText(
            // ".. .. .. .. .. .. .. ..",
            "Frontend Developer",
            0.6,
            this.subtitleFontColor,
            new THREE.Vector3(0, 2, 0.3),
            true
        )
        this.setText(
            // ".. .. .. .. .. .. .. ..",
            "Delhi, India",
            0.6,
            this.subtitleFontColor,
            new THREE.Vector3(8, 4.2, 0.3),
            true
        )
        this.locationIcon = this.setEmoji(" 📌 ", new THREE.Vector3(10.7, 4.2, 0.3), 1.1)

        // Menu Items
        // this.menuItems = []

        this.menuItems.push(this.setText(
            "Projects",
            this.subtitleFontSize,
            this.subtitleFontColor,
            new THREE.Vector3(0, this.startingHeight, 0.3),
            true,
            Projects
        ))

        this.menuItems.push(this.setText(
            "Experience",
            this.subtitleFontSize,
            this.subtitleFontColor,
            new THREE.Vector3(0, this.startingHeight - this.gap, 0.3),
            true,
            Jobs
        ))
        this.menuItems.push(this.setText(
            "Workshop",
            this.subtitleFontSize,
            this.subtitleFontColor,
            new THREE.Vector3(0, this.startingHeight - this.gap * 2, 0.3),
            true,
            Lab
        ))

        this.menuItems.push(this.setText(
            "Contact",
            this.subtitleFontSize,
            this.subtitleFontColor,
            new THREE.Vector3(0, this.startingHeight - (this.gap * 3), 0.3),
            true,
            Contact
        ))
    }

    setEmoji(emoji, position, scale = 1.0) {
        const canvas = document.createElement("canvas")
        canvas.width = 128
        canvas.height = 128

        const ctx = canvas.getContext("2d")
        ctx.font = "96px 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', sans-serif"
        ctx.textAlign = "center"
        ctx.textBaseline = "middle"
        ctx.fillText(emoji, 64, 64)

        const texture = new THREE.CanvasTexture(canvas)
        texture.colorSpace = THREE.SRGBColorSpace

        const sprite = new THREE.Sprite(
            new THREE.SpriteMaterial({ map: texture, transparent: true })
        )
        sprite.scale.set(scale, scale, 1)
        sprite.position.copy(position)

        this.scene.add(sprite)
        this.objects.push(sprite)
        return sprite
    }

    setText(value, fontSize, fontColor, textPosition, center = false, page) {
        const geometry = new TextGeometry(value, {
            font: this.font,
            size: fontSize,
            depth: 0,
            curveSegments: 12
        })

        if (center) {
            geometry.center()
        }

        const text = new THREE.Mesh(
            geometry,
            new THREE.MeshBasicMaterial({
                color: fontColor
            })
        )
        text.position.copy(textPosition)
        this.scene.add(text)
        this.objects.push(text)
        text.text = value
        text.page = page
        return text
    }
    destroy() {
        this.interaction.destroy()

        for (const object of this.objects) {
            this.scene.remove(object)
            if (object.geometry) object.geometry.dispose()
            if (object.material) {
                const materials = Array.isArray(object.material) ? object.material : [object.material]
                for (const material of materials) {
                    if (material.map) material.map.dispose()
                    material.dispose()
                }
            }
        }
    }
}
